import React, { forwardRef, useImperativeHandle } from 'react';
import { Form } from '@ant-design/compatible';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import BaseForm from '../../../../../../../components/form/BaseForm/BaseForm';
import ImageAndVideoUploadV2 from '../../../../../../../components/input/ImageAndVideoUploadV2';
import ClickLayers from './ClickLayers';
import { formRequiredRules } from '../../../../../../../lib/formRules';
import useClickLayerState from './useClickLayerState';
import { MAXIMUM_NUMBER_OF_EVENT_IMAGE_SECTION_TYPE_IMG } from '../../../../../../../constants/service/app/eventConstants';
import { Attachment } from '../../../../../../../components/input/ImageAndVideoUploadV2/types';
import { EventSectionAttachment, EventSectionClickLayer } from '../../../../../../../types/query/event';

interface ImageSectionRef {
  value?: Attachment[];
  onChange?: (attachmentList: Attachment[]) => void;
}

interface ImageSectionProps extends FormComponentProps {
  name: string;
  value?: Attachment[];
  onChange?: (attachmentList: Attachment[]) => void;
  sectionClickLayerList?: EventSectionClickLayer[];
}

const ImageSection = forwardRef<ImageSectionRef, ImageSectionProps>((props: ImageSectionProps, ref) => {
  const { name, value, onChange, form, sectionClickLayerList } = props;
  const [clickLayer, setClickLayer] = useClickLayerState(sectionClickLayerList);

  useImperativeHandle(ref, () => ({
    value,
    onChange,
  }));

  const handleDeleteImage = () => {
    form.setFieldsValue({
      [`${name}-attachments`]: [],
    });

    setClickLayer([]);
  };

  return (
    <>
      {value?.length ? (
        <ClickLayers
          name={name}
          form={form}
          initialValue={clickLayer}
          imgUrl={value[0]?.url || ''}
          onDeleteImage={handleDeleteImage}
        />
      ) : (
        <BaseForm
          label="기획전 섹션 이미지"
          required={true}
          vertical={true}
          content={
            <ImageAndVideoUploadV2
              value={value}
              modalTitle="기획전 섹션 이미지"
              maxCnt={MAXIMUM_NUMBER_OF_EVENT_IMAGE_SECTION_TYPE_IMG}
              enableGif
              capacityLimit={20}
              cropMode={false}
              onChange={onChange}
            />
          }
          subContent={
            <div className="sub-info">
              <div>* 폭 964 이하의 이미지 등록 시 기획전 화면이 어그러질 수 있습니다.</div>
              <div>* 가로 10,000 X 세로 10,000 픽셀 이하의 이미지만 등록이 가능 합니다.</div>
            </div>
          }
        />
      )}
    </>
  );
});
ImageSection.displayName = 'ImageSection';

interface ImageSectionFormProps extends FormComponentProps {
  name: string;
  sectionAttachmentList?: EventSectionAttachment[];
  sectionClickLayerList?: EventSectionClickLayer[];
}

const ImageSectionForm = (props: ImageSectionFormProps) => {
  const { form, name, sectionAttachmentList, sectionClickLayerList } = props;
  const { getFieldDecorator } = form;

  return (
    <div>
      <Form.Item>
        {getFieldDecorator(`${name}-attachments`, {
          rules: [formRequiredRules(true, '필수 정보입니다.', false, 'array')],
          initialValue: sectionAttachmentList,
        })(<ImageSection name={name} form={form} sectionClickLayerList={sectionClickLayerList} />)}
      </Form.Item>
    </div>
  );
};

export default ImageSectionForm;
